
const PercentageIcon = ({ flow }) => {
  return (
    <>
      {flow === "up" ? (
        <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M7.5 0.5V1.25H9.96975L6.75 4.46975L5.14012 2.85988C5.0698 2.78957 4.97444 2.75008 4.875 2.75008C4.77556 2.75008 4.6802 2.78957 4.60988 2.85988L0.75 6.71975L1.28025 7.25L4.875 3.65525L6.48487 5.26513C6.5552 5.33543 6.65056 5.37492 6.75 5.37492C6.84944 5.37492 6.9448 5.33543 7.01513 5.26513L10.5 1.78025V4.25H11.25V0.5H7.5Z"
            fill="#50C878"
          />
        </svg>
      ) : (
        <svg width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M7 7.5V6.75H9.46975L6.25 3.53025L4.64012 5.14012C4.5698 5.21043 4.47444 5.24992 4.375 5.24992C4.27556 5.24992 4.1802 5.21043 4.10988 5.14012L0.25 1.28025L0.78025 0.75L4.375 4.34475L5.98487 2.73487C6.0552 2.66457 6.15056 2.62508 6.25 2.62508C6.34944 2.62508 6.4448 2.66457 6.51513 2.73487L10 6.21975V3.75H10.75V7.5H7Z"
            fill="#E77B7B"
          />
        </svg>
      )}
    </>
  );
};

export default PercentageIcon;
